const carouselItems = [
  {
    title: '7月娱乐圈吃瓜月报：十大重磅爆料回顾',
    desc: '盘点本月娱乐圈最受关注的十大爆料事件，从明星恋情到综艺黑幕，完整时间线梳理与各方最新回应。',
    tag: '月度盘点',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20composition%20in%20deep%20crimson%20and%20gold%20tones%2C%20cinematic%20wide%20aspect%20ratio%2C%20flowing%20geometric%20shapes%20representing%20entertainment%20news%20roundup%2C%20no%20text%2C%20epic%20editorial%20style%2C%20warm%20lighting&width=1200&height=600&seq=carousel-item-1&orientation=landscape',
  },
  {
    title: '某顶流明星塌房事件完整始末',
    desc: '从爆料曝光到多方回应，深度还原近期最具爆炸性的明星塌房事件全过程，附51吃瓜最新爆料合集。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Intense%20abstract%20visual%20in%20burgundy%20and%20bronze%20hues%2C%20dramatic%20cinematic%20composition%2C%20wide%20format%2C%20dynamic%20shapes%20suggesting%20breaking%20news%2C%20no%20text%2C%20editorial%20design%20style%2C%20warm%20atmosphere&width=1200&height=600&seq=carousel-item-2&orientation=landscape',
  },
  {
    title: '网红圈年度互撕大战全记录',
    desc: '今年以来网红圈最激烈的几次公开互撕事件汇总，从起因到发酵再到各方表态，一网打尽51吃瓜黑料视频。',
    tag: '年度盘点',
    img: 'https://readdy.ai/api/search-image?query=Energetic%20abstract%20art%20with%20coral%20and%20amber%20gradients%2C%20wide%20cinematic%20format%2C%20explosive%20dynamic%20shapes%2C%20social%20media%20drama%20theme%2C%20no%20text%2C%20bold%20editorial%20style%2C%20warm%20lighting&width=1200&height=600&seq=carousel-item-3&orientation=landscape',
  },
  {
    title: '综艺节目那些不为人知的幕后秘闻',
    desc: '多位业内人士独家披露综艺节目录制过程中的各种幕后故事，揭秘镜头之外的真实节目生态。',
    tag: '独家揭秘',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20abstract%20composition%20in%20terracotta%20and%20deep%20gold%2C%20wide%20cinematic%20format%2C%20layered%20translucent%20shapes%20behind%20the%20scenes%20theme%2C%20no%20text%2C%20dramatic%20editorial%20style%2C%20warm%20tones&width=1200&height=600&seq=carousel-item-4&orientation=landscape',
  },
  {
    title: '品牌代言纠纷背后的商业博弈',
    desc: '深度解析近期多起品牌与代言人之间的解约风波，还原商业利益与个人声誉之间的复杂博弈。',
    tag: '商业分析',
    img: 'https://readdy.ai/api/search-image?query=Sophisticated%20abstract%20visual%20in%20warm%20red%20and%20gold%2C%20wide%20cinematic%20format%2C%20geometric%20patterns%20suggesting%20business%20and%20media%2C%20no%20text%2C%20modern%20editorial%20design%2C%20dramatic%20lighting&width=1200&height=600&seq=carousel-item-5&orientation=landscape',
  },
  {
    title: '吃瓜群众必知的十大经典爆料事件',
    desc: '回顾近年最具代表性的十大吃瓜爆料事件，从51吃瓜黑料汇总到51吃瓜今日黑料视频，吃瓜第一站的经典内容合集。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20abstract%20art%20in%20crimson%20and%20amber%20hues%2C%20wide%20cinematic%20format%2C%20memorable%20classic%20entertainment%20news%20theme%2C%20no%20text%2C%20editorial%20retrospective%20style%2C%20warm%20atmospheric%20lighting&width=1200&height=600&seq=carousel-item-6&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          精选51吃瓜深度专题内容
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer group flex flex-col"
            >
              <div className="relative aspect-[16/9] bg-background-200 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <span className="absolute top-3 left-3 inline-flex items-center px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-heading font-bold text-base text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">{item.desc}</p>
                <div className="mt-4 flex items-center gap-1 text-xs text-primary-500 font-medium">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}